import { render, staticRenderFns } from "./scrapInfo.vue?vue&type=template&id=0df68b96&scoped=true&"
import script from "./scrapInfo.vue?vue&type=script&lang=js&"
export * from "./scrapInfo.vue?vue&type=script&lang=js&"
import style0 from "./scrapInfo.vue?vue&type=style&index=0&id=0df68b96&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df68b96",
  null
  
)

export default component.exports